import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { Modal } from "./Modal";

interface MediaSettingsModalProps {
  signedId: string;
}

const MediaSettingsModalComponent = ({ signedId }: MediaSettingsModalProps) => {
  const modal = useModal();

  return (
    <Modal isOpen={modal.visible} onClose={modal.hide} signedId={signedId} />
  );
};

const MediaSettingsModal = ModalManager.create(
  (props: MediaSettingsModalProps) => (
    <MediaSettingsModalComponent {...props} />
  ),
);

export const useMediaSettingsModal = () => useModal(MediaSettingsModal);
